import getObject from 'utils/accessors/getObject.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectSalonList = ($) => $?.salon?.salonList ?? null;
export const selectSalonListObject = ($) => $?.salon?.salonList ?? {};
export const selectSalonListOk = ($) => $?.salon?.salonList?.ok ?? null;

export const selectSalonManagers = nullBind(getObject, 'salon.salonList.response.manager');
export const selectSalonReceptionists = nullBind(getObject, 'salon.salonList.response.receptionist');

export const selectCategoryList = ($) => $?.salonInfo?.categoryList ?? [];
export const selectCategoryMap = ($) => $?.salonInfo?.categoryMap ?? {};

export const selectServiceList = ($) => $?.salonInfo?.serviceList ?? [];
export const selectServiceMap = ($) => $?.salonInfo?.serviceMap ?? {};

export const selectStylistList = ($) => $?.salonInfo?.stylistsList ?? [];
export const selectStylistMap = ($) => $?.salonInfo?.stylistsMap ?? {};
